import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import { RouterProvider } from "react-router-dom";
import router from "./routes/routerConfig";
import { Amplify } from "aws-amplify";
import config from "../src/configs/amplifyconfiguration_new.json";
import prodConfig from "../src/configs/prod-amplify.json";
import { Provider } from "react-redux";
import store from "./state/store";
import { isProd } from "./utlis/helpers";

const uploadFile = isProd ? prodConfig : config;
Amplify.configure(uploadFile);
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <RouterProvider router={router} />
  </Provider>,
);
